import { createInfiniteQuery, createQuery } from 'react-query-kit';

import { fetchData } from 'services/http/http';
import { buildFilterUrl } from 'support/helpers/urls/urls';
import { InvoiceVerificationDTO } from 'support/types';
import portalSchema from 'support/types/schema-portal';
import { Filter } from 'components/ListTable/types';

export const INVOICE_VERIFICATION_QUERY_KEY = '/invoice-verification';

export type InvoiceVerificationResponseDTO =
  portalSchema.paths['/v1/invoice-verification']['get']['responses']['200']['content']['application/json'];

export const useInfiniteInvoiceVerification = createInfiniteQuery<
  InvoiceVerificationResponseDTO,
  { query?: Filter },
  Error
>({
  primaryKey: INVOICE_VERIFICATION_QUERY_KEY,
  queryFn: async ({ queryKey: [, variables], pageParam }) => {
    const urlParams = buildFilterUrl({ ...variables.query, cursor: pageParam }, { forApiRequest: true });

    const { data } = await fetchData<InvoiceVerificationResponseDTO>('/v1/invoice-verification' + urlParams);

    return data;
  },
  getNextPageParam: (lastPage) => lastPage.meta?.next_cursor,
  getPreviousPageParam: (_, allPages) => allPages?.at(-1)?.meta?.prev_cursor,
});

export const useInvoiceVerificationDetail = createQuery<InvoiceVerificationDTO, { id: string | undefined }, Error>({
  primaryKey: `${INVOICE_VERIFICATION_QUERY_KEY}/:id`,
  queryFn: async ({ queryKey: [, variables] }) => {
    const { data } = await fetchData<{ data: InvoiceVerificationDTO }>(`/v1/invoice-verification/${variables.id}`);

    return data.data;
  },
  enabled: (_, variables) => Boolean(variables.id),
});
